import { useCallback, useEffect, useState } from 'react'
import { api, ApiError } from '@/lib/api'

// TODO test: hook devuelve isLoading=true inicialmente y false tras el fetch
// TODO test: hook devuelve el array de cargos cuando el API responde 200
// TODO test: hook devuelve error cuando el API responde 4xx/5xx
// TODO test: no dispara un segundo fetch si cargos ya fueron cargados

export interface Cargo {
  id: number
  nombre: string
}

interface CargosResponse {
  data: Cargo[]
}

export function useCargos() {
  const [cargos, setCargos] = useState<Cargo[]>([])
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState<Error | null>(null)

  const fetchCargos = useCallback(async () => {
    setIsLoading(true)
    setError(null)
    try {
      const res = await api.get<CargosResponse>('/cargos')
      setCargos(res.data)
    } catch (e) {
      const err =
        e instanceof ApiError ? e : new Error('Error al cargar los cargos')
      setError(err)
      setCargos([])
    } finally {
      setIsLoading(false)
    }
  }, [])

  useEffect(() => {
    fetchCargos()
  }, [fetchCargos])

  return { cargos, isLoading, error }
}
